import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { var_api } from "../../../constant";
import { Link } from "react-router-dom";
            import Select from "react-select";

const AttendanceMaster = () => {
  const tableHeaders = [
    "#",
    "Date",
    "Check-In Time",
    "Check-Out Time",
    "Worked Hours",
    "Status",
    "Remarks",
    "Action",
  ];

  const [attendanceData, setAttendanceData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    warehouse_id: 1,
    staff_id: "",
    attendance_date: "",
    check_in_time: "",
    check_out_time: "",
    worked_hours: "",
    status: "Present",
    remarks: "",
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const itemsPerPage = 15;

  useEffect(() => {
    const storedStaffId = localStorage.getItem("staff_id");
    if (storedStaffId) {
      setFormData((prev) => ({ ...prev, staff_id: storedStaffId }));
    }
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      const res = await axios.get(`${var_api}veemart_staff_attendance/get`);
      setAttendanceData(res.data || []);
    } catch {
      toast.error("Failed to fetch attendance data");
    } finally {
      setInitialLoading(false);
    }
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;

  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));

  //   setErrors((prev) => ({
  //     ...prev,
  //     [name]: "",
  //   }));
  // };
const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`; // for input type="date"
};

const formatTimeForInput = (isoString) => {
  if (!isoString) return "";
  const date = new Date(isoString);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`; // for input type="time"
};

  const handleAddClick = () => {
    const storedStaffId = localStorage.getItem("staff_id") || "";
    setFormData({
      id: null,
      warehouse_id: 1,
      staff_id: storedStaffId,
      attendance_date: "",
      check_in_time: "",
      check_out_time: "",
      worked_hours: "",
      status: "Present",
      remarks: "",
    });
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };
const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};


  const handleEditClick = (item) => {
  setFormData({
    ...item,
    attendance_date: formatDateForInput(item.attendance_date),
    check_in_time: formatTimeForInput(item.check_in_time),
    check_out_time: formatTimeForInput(item.check_out_time),
  });
  setIsEditMode(true);
  setErrors({});
  setShowModal(true);
};

const formatTime = (isoString) => {
  if (!isoString) return "";
  const date = new Date(isoString);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
};

const handleInputChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  // 🔹 Remove error message for that specific field when value is entered
  setErrors((prev) => ({
    ...prev,
    [name]: value ? "" : prev[name],
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();

  const newErrors = {};

  if (!formData.attendance_date)
    newErrors.attendance_date = "Please select a date";
  if (!formData.check_in_time)
    newErrors.check_in_time = "Please select check-in time";
  if (!formData.check_out_time)
    newErrors.check_out_time = "Please select check-out time";

  // Basic field validations
  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    toast.warning("Please correct the highlighted fields");
    return;
  }

  // ✅ Check that check-out time > check-in time
  const checkIn = new Date(`${formData.attendance_date}T${formData.check_in_time}`);
  const checkOut = new Date(`${formData.attendance_date}T${formData.check_out_time}`);

  if (checkOut <= checkIn) {
    toast.error("Check-out time must be later than check-in time!");
    return;
  }

  try {
    setLoading(true);

    // ✅ Convert date + time to ISO
    const formatToISO = (date, time) => {
      if (!date || !time) return null;
      const [hours, minutes] = time.split(":");
      const formattedDate = new Date(date);
      formattedDate.setHours(hours, minutes, 0, 0);
      return formattedDate.toISOString();
    };

    const payload = {
      ...formData,
      attendance_date: new Date(formData.attendance_date).toISOString(),
      check_in_time: formatToISO(formData.attendance_date, formData.check_in_time),
      check_out_time: formatToISO(formData.attendance_date, formData.check_out_time),
    };

    let res;
    if (isEditMode && formData.id) {
      res = await axios.put(
        `${var_api}veemart_staff_attendance/update/${formData.id}`,
        payload
      );
    } else {
      res = await axios.post(`${var_api}veemart_staff_attendance/post`, payload);
    }

    toast.success(res?.data?.message || "Attendance saved successfully!");
    setShowModal(false);
    loadInitialData();
  } catch (err) {
    toast.error(err?.response?.data?.message || "Failed to save attendance");
  } finally {
    setLoading(false);
  }
};





  const filteredData = attendanceData.filter((item) =>
    Object.values(item).some((val) =>
      String(val).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <Button variant="secondary" onClick={handleAddClick}>
                  Add
                </Button>
              </div>

              <div className="table-responsive">
                <table className="table ">
                  <thead>
                    <tr>
                      {tableHeaders.map((header, idx) => (
                        <th key={idx}>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center text-muted py-3">
                          No data found
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
<td>{formatDate(item.attendance_date)}</td>
                        <td>{formatTime(item.check_in_time)}</td>
<td>{formatTime(item.check_out_time)}</td>

                          <td>{item.worked_hours}</td>
                          <td>
                            <span
                              className={`badge ${
                                item.status === "Present"
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {item.status}
                            </span>
                          </td>
                          <td>{item.remarks}</td>
                          <td className="text-center">
                            <Link to="#" className="btn shadow btn-xs sharp me-1" style={{ backgroundColor: "#007bff", color: "white" }} onClick={() => handleEditClick(item)}>
                            <i className="fas fa-pencil-alt"></i>
                          </Link>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>

        {/* Modal */}
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {isEditMode ? "Edit Attendance" : "Add Attendance"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
              <Col md={4}>
  <Form.Group className="mb-3">
    <Form.Label>Date <span className="text-danger">*</span> </Form.Label>
    <Form.Control
      type="date"
      name="attendance_date"
      value={formData.attendance_date}
      onChange={handleInputChange}
      isInvalid={!!errors.attendance_date}
    />
    {errors.attendance_date && (
      <div className="text-danger small mt-1">{errors.attendance_date}</div>
    )}
  </Form.Group>
</Col>

<Col md={4}>
  <Form.Group className="mb-3">
    <Form.Label>Check-In Time <span className="text-danger">*</span></Form.Label>
    <Form.Control
      type="time"
      name="check_in_time"
      value={formData.check_in_time}
      onChange={handleInputChange}
      isInvalid={!!errors.check_in_time}
    />
    {errors.check_in_time && (
      <div className="text-danger small mt-1">{errors.check_in_time}</div>
    )}
  </Form.Group>
</Col>

<Col md={4}>
  <Form.Group className="mb-3">
    <Form.Label>Check-Out Time <span className="text-danger">*</span></Form.Label>
    <Form.Control
      type="time"
      name="check_out_time"
      value={formData.check_out_time}
      onChange={handleInputChange}
      isInvalid={!!errors.check_out_time}
    />
    {errors.check_out_time && (
      <div className="text-danger small mt-1">{errors.check_out_time}</div>
    )}
  </Form.Group>
</Col>


                {/* <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Worked Hours</Form.Label>
                    <Form.Control
                      type="text"
                      name="worked_hours"
                      placeholder="e.g. 8:30"
                      value={formData.worked_hours}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col> */}


<Col md={4}>
  <Form.Group className="mb-3">
    <Form.Label>Status</Form.Label>
    <Select
      name="status"
      placeholder="Select Status"
      options={[
        { label: "Present", value: "Present" },
        { label: "Absent", value: "Absent" },
        { label: "Leave", value: "Leave" },
      ]}
      value={
        formData.status
          ? { label: formData.status, value: formData.status }
          : null
      }
      onChange={(selected) =>
        setFormData({ ...formData, status: selected.value })
      }
      isClearable
      isSearchable
    />
  </Form.Group>
</Col>


                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control
                      type="text"
                      name="remarks"
                      placeholder="Enter remarks"
                      value={formData.remarks}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

                <div className="d-flex justify-content-end gap-2">
  {!isEditMode ? (
    <>
      <Button variant="secondary" type="submit" disabled={loading}>
        {loading ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Creating...
          </>
        ) : (
          "Create"
        )}
      </Button>
      <Button
        variant="danger"
        type="reset"
        disabled={loading}
      onClick={() =>
  setFormData({
    id: null,
    warehouse_id: 1,
    staff_id: "",
    attendance_date: "",
    check_in_time: "",
    check_out_time: "",
    worked_hours: "",
    status: "Present",
    remarks: "",
  })
}

      >
        Reset
      </Button>
    </>
  ) : (
    <>
      <Button variant="warning" type="submit" disabled={loading}>
        {loading ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Updating...
          </>
        ) : (
          "Update"
        )}
      </Button>
      <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>
        Cancel
      </Button>
    </>
  )}
</div>
            </Form>
          </Modal.Body>
        </Modal>
      </Card>

      <ToastContainer />
    </>
  );
};

export default AttendanceMaster; 